import { Navigate, Outlet } from "react-router";
import { useMe } from "../../hooks/useMe";

export const RequireAuth = () => {
  const { user, loading, statusCode } = useMe();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-sm text-muted-foreground">Loading dashboard…</div>
      </div>
    );
  }

  if (statusCode === 423) {
    return <Navigate to="/maintenance" replace />;
  }

  if (statusCode === 401 || !user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
